import styled from 'styled-components';

// Base button style to be shared across components
export const BaseButton = styled.button`
  background: ${props => props.$active ? '#10d174' : 'black'};
  color: ${props => props.$active ? 'black' : 'white'};
  font-weight: bold;
  border-radius: 12px;
  border: 2px solid black;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 2px 2px 0 black;

  &:hover {
    background: ${props => props.$active ? '#0db863' : '#333'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Nav button style (used in header)
export const NavButtonStyle = styled(BaseButton)`
  padding: 8px 16px;
  font-size: 0.9rem;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Play button style (used for LET'S PLAY)
export const PlayButtonStyle = styled(BaseButton)`
  padding: 10px 30px;
  font-size: 1.25rem;
`; 